import { AscensorActividadesProvider } from 'providers/AscensorActividadesProvider';
import { ClienteProvider } from 'providers/Clientes/ClienteProvider';
import React from 'react';
import ClienteActividadesPage from './ClienteActividadesPage';

const ClienteActividadesPageWrapper = ({ id }) => {
  return (
    <ClienteProvider id={id}>
      <AscensorActividadesProvider id={id}>
        <ClienteActividadesPage id={id} />
      </AscensorActividadesProvider>
    </ClienteProvider>
  );
};

export default ClienteActividadesPageWrapper;

